// ABOUTME: Hook for managing week summary collapsed state with localStorage persistence
// ABOUTME: Used to show/hide the week summary sidebar in calendar view

import { useCallback, useSyncExternalStore } from "react"
import { STORAGE_KEYS } from "@shared/constants/storageKeys"

// Type guard to validate parsed localStorage value is a boolean
const isBoolean = (value: unknown): value is boolean => {
  return typeof value === "boolean"
}

// Global state to sync all subscribers
let listeners: (() => void)[] = []
let currentValue: boolean = (() => {
  try {
    const saved = localStorage.getItem(STORAGE_KEYS.WEEK_SUMMARY_COLLAPSED)
    if (!saved) return false
    const parsed: unknown = JSON.parse(saved)
    return isBoolean(parsed) ? parsed : false
  } catch {
    return false
  }
})()

const subscribe = (listener: () => void) => {
  listeners = [...listeners, listener]
  return () => {
    listeners = listeners.filter((l) => l !== listener)
  }
}

const getSnapshot = () => currentValue

const setCollapsed = (value: boolean) => {
  currentValue = value
  localStorage.setItem(STORAGE_KEYS.WEEK_SUMMARY_COLLAPSED, JSON.stringify(value))
  listeners.forEach((listener) => listener())
}

export const useWeekSummaryCollapsed = () => {
  const isCollapsed = useSyncExternalStore(subscribe, getSnapshot)

  const toggle = useCallback(() => {
    setCollapsed(!currentValue)
  }, [])

  return { isCollapsed, setIsCollapsed: setCollapsed, toggle }
}
